import { IHttpApi, Order, W_Status } from '.';

export class MockHttpClient implements IHttpApi {

  async read_current_user() {
    return {
      id: '1',
      name: 'Massimiliano D.',
      started_at: Date.now() - 1000 * 60 * 9,
      role: 'supervisor',
      is_admin: true,
    }
  }

  async current_machine_status() {
    return {
      current: {
        status_code: W_Status.ATTESA,
        state_start_unix_timestamp: Date.now() - 1000 * 60 * 9,
        order: 'WO334-FF449A',
        article: 'A12667089',
        article_description: 'Caldaia ⌀70cm Mod. Silver Special lorem ipsum dolor sit ame',
        program: 'R16536-V40',
        goods: 130,
        wastes: 12,
        expected_goods: 150,
        expected_end_time: 1000 * 60 * 60 * 2,
        energy: 12.4,
        power: 3.4,
        alarms: [
          {
            code: "\"Supervisor\".\"Alarm\"[1]",
            name: "[Fault1] SI:0_MN:1",
            text: "No communication Unified Mobile Panel",
            value: true,
            type: "ALARM" as const,
            unix_start: 1739739466965
          }
        ],
        parameters: WS_PARAMS,
        stations: WS_STATIONS
      },
      workcenter_info: {
        wc_id: 102,
        wc_code: "PLC-OPCUA-2",
        wc_name: "PLC-OPCUA",
        wc_ip_address: "10.69.111.2",
        wc_port: "4840",
        subcenters: new Array(10).fill(0).map((_, i) => ({
          sub_ws_id: i + 1,
          sub_ws_code: String(i + 1),
          sub_ws_name: `STATION_${i + 1}`,
          sub_ws_position: POSITIONS[i] || null,
          wc_id: 102
        }))
      },
      oee: 0,
    }
  }

  async list_orders(): Promise<Order[]> {
    return ORDERS;
  }

  async list_alarms() {
    return ALARMS;
  }

  static setup() {
    return new MockHttpClient();
  }


}


const POSITIONS = [
  [866, 497],
  [225, 571],
  [260, 396],
  [227, 211],
  [593, 138],
  [694, 182],
].map(p => JSON.stringify(p))

const WS_PARAMS = [
  {
    "code": "Connected",
    "name": "Connected",
    "value": "True",
    "type": "bool",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "StatusCode",
    "name": "Status Code",
    "value": "ATTESA",
    "type": "int",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Energy",
    "name": "Energy",
    "value": "0 kWh",
    "type": "double",
    "measurement_unit": "kWh",
    "scalar": 1,
    "decimal_places": 2
  },
  {
    "code": "TotalEnergy",
    "name": "Total Energy",
    "value": "0 kWh",
    "type": "double",
    "measurement_unit": "kWh",
    "scalar": 1,
    "decimal_places": 2
  },
  {
    "code": "Gas",
    "name": "Gas",
    "value": "0 m³",
    "type": "double",
    "measurement_unit": "m³",
    "scalar": 1000,
    "decimal_places": 2
  },
  {
    "code": "TotalGas",
    "name": "Total Gas",
    "value": "0 m³",
    "type": "double",
    "measurement_unit": "m³",
    "scalar": 1000,
    "decimal_places": 2
  },
  {
    "code": "ActivePower",
    "name": "Active Power",
    "value": "0 W",
    "type": "double",
    "measurement_unit": "W",
    "scalar": 1,
    "decimal_places": 2
  },
  {
    "code": "ReactivePower",
    "name": "Reactive Power",
    "value": "0 kVAR",
    "type": "double",
    "measurement_unit": "kVAR",
    "scalar": 1,
    "decimal_places": 2
  },
  {
    "code": "Goods",
    "name": "Goods",
    "value": "0",
    "type": "decimal",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Wastes",
    "name": "Wastes",
    "value": "0",
    "type": "decimal",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Order",
    "name": "Order",
    "value": "",
    "type": "string",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Program",
    "name": "Program Name",
    "value": "",
    "type": "string",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Ip",
    "name": "Ip Address",
    "value": "10.69.111.2",
    "type": "string",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Port",
    "name": "Port",
    "value": "4840",
    "type": "string",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "Adapter",
    "name": "Adapter",
    "value": "LEAS",
    "type": "string",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  },
  {
    "code": "SubcenterId",
    "name": "Subcenter Id",
    "value": "PLC-OPCUA-2",
    "type": "int",
    "measurement_unit": "",
    "scalar": 1,
    "decimal_places": 0
  }
]

const WS_STATIONS = [
  {
    "connected": false,
    "alarms": [
      {
        "code": "\"Supervisor\".\"Alarm\"[98]",
        "name": "[Fault98] SI:1_MN:1",
        "text": "[98] No description",
        "value": true,
        "type": "ALARM" as const,
        "start": "2025-02-16T21:57:46",
        "active_seconds": 0,
        "unix_start": 1739739466965
      },
      {
        "code": "\"Supervisor\".\"Alarm\"[99]",
        "name": "[Fault99] SI:1_MN:1",
        "text": "[99] No description",
        "value": true,
        "type": "ALARM" as const,
        "start": "2025-02-16T21:57:46",
        "active_seconds": 0,
        "unix_start": 1739739466965
      }
    ],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "1",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "1",
    "center_id": 1
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "2",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "2",
    "center_id": 2
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "3",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "3",
    "center_id": 3
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "4",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "4",
    "center_id": 4
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "5",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "5",
    "center_id": 5
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "6",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "6",
    "center_id": 6
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "7",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "7",
    "center_id": 7
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "8",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "8",
    "center_id": 8
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "9",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "9",
    "center_id": 9
  },
  {
    "connected": false,
    "alarms": [],
    "parameters": [
      {
        "code": "AUT_BTN_PUSH",
        "name": "Automatic Button Pushed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "AUT_MODE",
        "name": "Automatic Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "FLT_PRESENT",
        "name": "Fault Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOME_POS_START",
        "name": "Home Position Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "HOMED",
        "name": "Homed",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MAN_MODE",
        "name": "Manual Mode",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "MSG_PRESENT",
        "name": "Message Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "START",
        "name": "Start",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ID",
        "name": "Station ID",
        "value": "10",
        "type": "Int16",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STATION_ENABLE",
        "name": "Station Enable",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOP",
        "name": "Stop",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "STOPPING",
        "name": "Stopping",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      },
      {
        "code": "WARN_PRESENT",
        "name": "Warning Present",
        "value": "False",
        "type": "Boolean",
        "measurement_unit": "",
        "scalar": 1,
        "decimal_places": 3
      }
    ],
    "stations": [],
    "ip": "",
    "port": "",
    "adapter": "",
    "order": "",
    "article": "",
    "article_description": "",
    "program": "",
    "status_code": 0,
    "energy": 0,
    "total_energy": 0,
    "gas": 0,
    "total_gas": 0,
    "active_power": 0,
    "reactive_power": 0,
    "power": 0,
    "total_power": 0,
    "goods": 0,
    "wastes": 0,
    "center_code": "10",
    "center_id": 10
  }
].map(w => ({
  ...w, state_start_unix_timestamp: Date.now(), expected_end_time: Date.now() + 1000 * 60 * 60 * 24, expected_goods: 150
}))

const ORDERS: Order[] = [
  {
    "wk_id": 0,
    "wc_id": 102,
    "ws_id": null,
    "re_code": "R145556-V22",
    "wk_working_time": 16600,
    "wk_expected_setup_time": 0,
    "wk_expected_working_time": 0,
    "wk_goods": 335,
    "wk_wastes": 35,
    "wk_energy": 4500,
    "wk_gas": 1600,
    "wk_notes": null,
    "wk_status_code": 2,
    "wo_code": "WO10-FF10",
    "wo_ordered_quantity": 150,
    "ar_code": "A12667089",
    "ar_name": "Caldaia ⌀70cm Mod. Silver Special lorem ipsum dolor sit am",
    "wk_timestamp": "0001-01-01T00:00:00",
    "wk_datestamp": "0001-01-01T00:00:00",
    "wk_unix_start": Date.now(),
    "wk_unix_finish": Date.now() + 1000 * 60 * 60 * 24,
    wk_setup_time: 0,
  },
]

const ALARMS = [
  {
    "al_unix_start": 1739739967000,
    "al_unix_end": 1739747055261,
    "al_id": 65,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T22:06:07",
    "al_start": "2025-02-16T22:06:07",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739739967000,
    "al_unix_end": 1739747055261,
    "al_id": 66,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T22:06:07",
    "al_start": "2025-02-16T22:06:07",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739739946000,
    "al_unix_end": 1739739960000,
    "al_id": 63,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T22:06:00",
    "al_start": "2025-02-16T22:05:46",
    "al_stop": "2025-02-16T22:06:00"
  },
  {
    "al_unix_start": 1739739947000,
    "al_unix_end": 1739739960000,
    "al_id": 64,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T22:06:00",
    "al_start": "2025-02-16T22:05:47",
    "al_stop": "2025-02-16T22:06:00"
  },
  {
    "al_unix_start": 1739739193000,
    "al_unix_end": 1739747055271,
    "al_id": 61,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T21:53:13",
    "al_start": "2025-02-16T21:53:13",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739739193000,
    "al_unix_end": 1739747055280,
    "al_id": 62,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T21:53:13",
    "al_start": "2025-02-16T21:53:13",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739738995000,
    "al_unix_end": 1739739186000,
    "al_id": 60,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T21:53:07",
    "al_start": "2025-02-16T21:49:55",
    "al_stop": "2025-02-16T21:53:06"
  },
  {
    "al_unix_start": 1739738994000,
    "al_unix_end": 1739739186000,
    "al_id": 59,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T21:53:06",
    "al_start": "2025-02-16T21:49:54",
    "al_stop": "2025-02-16T21:53:06"
  },
  {
    "al_unix_start": 1739735767000,
    "al_unix_end": 1739747055296,
    "al_id": 57,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:56:07",
    "al_start": "2025-02-16T20:56:07",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739735767000,
    "al_unix_end": 1739747055302,
    "al_id": 58,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:56:07",
    "al_start": "2025-02-16T20:56:07",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739735692000,
    "al_unix_end": 1739735760000,
    "al_id": 55,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:56:00",
    "al_start": "2025-02-16T20:54:52",
    "al_stop": "2025-02-16T20:56:00"
  },
  {
    "al_unix_start": 1739735692000,
    "al_unix_end": 1739735760000,
    "al_id": 56,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:56:00",
    "al_start": "2025-02-16T20:54:52",
    "al_stop": "2025-02-16T20:56:00"
  },
  {
    "al_unix_start": 1739735181000,
    "al_unix_end": 1739747055303,
    "al_id": 53,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:46:21",
    "al_start": "2025-02-16T20:46:21",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739735181000,
    "al_unix_end": 1739747055303,
    "al_id": 54,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:46:21",
    "al_start": "2025-02-16T20:46:21",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739734963000,
    "al_unix_end": 1739747055303,
    "al_id": 52,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:42:44",
    "al_start": "2025-02-16T20:42:43",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739734963000,
    "al_unix_end": 1739747055307,
    "al_id": 51,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:42:43",
    "al_start": "2025-02-16T20:42:43",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739734929000,
    "al_unix_end": 1739734956000,
    "al_id": 49,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:42:36",
    "al_start": "2025-02-16T20:42:09",
    "al_stop": "2025-02-16T20:42:36"
  },
  {
    "al_unix_start": 1739734932000,
    "al_unix_end": 1739734956000,
    "al_id": 50,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:42:36",
    "al_start": "2025-02-16T20:42:12",
    "al_stop": "2025-02-16T20:42:36"
  },
  {
    "al_unix_start": 1739734837000,
    "al_unix_end": 1739747055316,
    "al_id": 47,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:40:38",
    "al_start": "2025-02-16T20:40:37",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739734837000,
    "al_unix_end": 1739747055316,
    "al_id": 48,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:40:38",
    "al_start": "2025-02-16T20:40:37",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739664596000,
    "al_unix_end": 1739734831000,
    "al_id": 45,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T20:40:31",
    "al_start": "2025-02-16T01:09:56",
    "al_stop": "2025-02-16T20:40:31"
  },
  {
    "al_unix_start": 1739664596000,
    "al_unix_end": 1739734831000,
    "al_id": 46,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T20:40:31",
    "al_start": "2025-02-16T01:09:56",
    "al_stop": "2025-02-16T20:40:31"
  },
  {
    "al_unix_start": 1739662876000,
    "al_unix_end": 1739664589000,
    "al_id": 43,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T01:09:49",
    "al_start": "2025-02-16T00:41:16",
    "al_stop": "2025-02-16T01:09:49"
  },
  {
    "al_unix_start": 1739662876000,
    "al_unix_end": 1739664589000,
    "al_id": 44,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T01:09:49",
    "al_start": "2025-02-16T00:41:16",
    "al_stop": "2025-02-16T01:09:49"
  },
  {
    "al_unix_start": 1739662416000,
    "al_unix_end": 1739747055393,
    "al_id": 41,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:33:36",
    "al_start": "2025-02-16T00:33:36",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739662416000,
    "al_unix_end": 1739747055393,
    "al_id": 42,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:33:36",
    "al_start": "2025-02-16T00:33:36",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739662222000,
    "al_unix_end": 1739747055394,
    "al_id": 39,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:30:22",
    "al_start": "2025-02-16T00:30:22",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739662222000,
    "al_unix_end": 1739747055400,
    "al_id": 40,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:30:22",
    "al_start": "2025-02-16T00:30:22",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739661854000,
    "al_unix_end": 1739662216000,
    "al_id": 37,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:30:16",
    "al_start": "2025-02-16T00:24:14",
    "al_stop": "2025-02-16T00:30:16"
  },
  {
    "al_unix_start": 1739661854000,
    "al_unix_end": 1739662216000,
    "al_id": 38,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:30:16",
    "al_start": "2025-02-16T00:24:14",
    "al_stop": "2025-02-16T00:30:16"
  },
  {
    "al_unix_start": 1739661229000,
    "al_unix_end": 1739747055403,
    "al_id": 35,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:13:49",
    "al_start": "2025-02-16T00:13:49",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739661229000,
    "al_unix_end": 1739747055405,
    "al_id": 36,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:13:49",
    "al_start": "2025-02-16T00:13:49",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739661016000,
    "al_unix_end": 1739747055407,
    "al_id": 33,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:10:17",
    "al_start": "2025-02-16T00:10:16",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739661016000,
    "al_unix_end": 1739747055413,
    "al_id": 34,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:10:17",
    "al_start": "2025-02-16T00:10:16",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660857000,
    "al_unix_end": 1739747055421,
    "al_id": 31,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:07:37",
    "al_start": "2025-02-16T00:07:37",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660857000,
    "al_unix_end": 1739747055478,
    "al_id": 32,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:07:37",
    "al_start": "2025-02-16T00:07:37",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660608000,
    "al_unix_end": 1739747055479,
    "al_id": 29,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-16T00:03:28",
    "al_start": "2025-02-16T00:03:28",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660608000,
    "al_unix_end": 1739747055480,
    "al_id": 30,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-16T00:03:28",
    "al_start": "2025-02-16T00:03:28",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660034000,
    "al_unix_end": 1739747055481,
    "al_id": 27,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:53:54",
    "al_start": "2025-02-15T23:53:54",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739660034000,
    "al_unix_end": 1739747055483,
    "al_id": 28,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:53:54",
    "al_start": "2025-02-15T23:53:54",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739659832000,
    "al_unix_end": 1739747055484,
    "al_id": 25,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:50:32",
    "al_start": "2025-02-15T23:50:32",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739659832000,
    "al_unix_end": 1739747055486,
    "al_id": 26,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:50:32",
    "al_start": "2025-02-15T23:50:32",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658977000,
    "al_unix_end": 1739747055504,
    "al_id": 23,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:36:17",
    "al_start": "2025-02-15T23:36:17",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658977000,
    "al_unix_end": 1739747055504,
    "al_id": 24,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:36:17",
    "al_start": "2025-02-15T23:36:17",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658770000,
    "al_unix_end": 1739747055505,
    "al_id": 21,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:32:50",
    "al_start": "2025-02-15T23:32:50",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658770000,
    "al_unix_end": 1739747055508,
    "al_id": 22,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:32:50",
    "al_start": "2025-02-15T23:32:50",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658662000,
    "al_unix_end": 1739747055508,
    "al_id": 20,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:31:03",
    "al_start": "2025-02-15T23:31:02",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658662000,
    "al_unix_end": 1739747055509,
    "al_id": 19,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:31:02",
    "al_start": "2025-02-15T23:31:02",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658495000,
    "al_unix_end": 1739747055511,
    "al_id": 17,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:28:15",
    "al_start": "2025-02-15T23:28:15",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658495000,
    "al_unix_end": 1739747055518,
    "al_id": 18,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:28:15",
    "al_start": "2025-02-15T23:28:15",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739658146000,
    "al_unix_end": 1739658489000,
    "al_id": 15,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:28:09",
    "al_start": "2025-02-15T23:22:26",
    "al_stop": "2025-02-15T23:28:09"
  },
  {
    "al_unix_start": 1739658146000,
    "al_unix_end": 1739658489000,
    "al_id": 16,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:28:09",
    "al_start": "2025-02-15T23:22:26",
    "al_stop": "2025-02-15T23:28:09"
  },
  {
    "al_unix_start": 1739657489000,
    "al_unix_end": 1739747055533,
    "al_id": 13,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:11:29",
    "al_start": "2025-02-15T23:11:29",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739657489000,
    "al_unix_end": 1739747055535,
    "al_id": 14,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:11:29",
    "al_start": "2025-02-15T23:11:29",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739657296000,
    "al_unix_end": 1739747055535,
    "al_id": 11,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:08:16",
    "al_start": "2025-02-15T23:08:16",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739657296000,
    "al_unix_end": 1739747055539,
    "al_id": 12,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:08:16",
    "al_start": "2025-02-15T23:08:16",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739656907000,
    "al_unix_end": 1739747055552,
    "al_id": 9,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[98]",
    "al_type": "ALARM" as const,
    "al_text": "[98] No description",
    "al_timestamp": "2025-02-15T23:01:47",
    "al_start": "2025-02-15T23:01:47",
    "al_stop": "2025-02-17T00:04:15"
  },
  {
    "al_unix_start": 1739656907000,
    "al_unix_end": 1739747055552,
    "al_id": 10,
    "wc_id": 102,
    "ws_id": 1,
    "al_code": "\"Supervisor\".\"Alarm\"[99]",
    "al_type": "ALARM" as const,
    "al_text": "[99] No description",
    "al_timestamp": "2025-02-15T23:01:47",
    "al_start": "2025-02-15T23:01:47",
    "al_stop": "2025-02-17T00:04:15"
  }
]